import React, { useContext } from "react";
import { ItemDetailsData } from "../../../../Utils/DefinitionsInterfaces";
import { CartContext } from "../../../../App";

interface ItemSummaryProps {
  items: ItemDetailsData[];
  selectedOption: "prepaid" | "cod";
}

const ItemSummary: React.FC<ItemSummaryProps> = ({ items, selectedOption }) => {
  const { bundleInfo, checkOutItems } = useContext(CartContext);

  // Check if bundle pricing should apply to a specific item
  const shouldShowBundlePrice = (itemId: number) => {
    if (!bundleInfo.isBundle || !bundleInfo.primaryProductId) return false;

    // Don't apply bundle pricing to the primary product itself
    if (itemId === bundleInfo.primaryProductId) return false;

    // Check if primary product is in the cart
    const primaryProductInCart = checkOutItems.some(
      (item) => item.id === bundleInfo.primaryProductId
    );

    return primaryProductInCart;
  };

  const getDisplayPrice = (item: ItemDetailsData) => {
    return shouldShowBundlePrice(item.id)
      ? item.discountedBundlePrice
      : item.selling_price;
  };

  // Get coupon data from session storage
  const getCouponData = () => {
    const appliedCouponCode = sessionStorage.getItem("appliedCouponCode");
    const couponDiscountAmount = sessionStorage.getItem("couponDiscountAmount");

    if (appliedCouponCode && couponDiscountAmount) {
      return {
        isApplied: true,
        code: appliedCouponCode,
        discountAmount: parseFloat(couponDiscountAmount),
      };
    }

    return {
      isApplied: false,
      code: "",
      discountAmount: 0,
    };
  };

  const couponData = getCouponData();
  const totalBasePrice = items.reduce((acc, item) => acc + item.base_price, 0);
  const totalSellingPrice = items.reduce(
    (acc, item) => acc + getDisplayPrice(item),
    0
  );
  const totalDiscount = totalBasePrice - totalSellingPrice;
  const couponDiscount = couponData.isApplied ? couponData.discountAmount : 0;
  const codCharges =
    selectedOption === "cod" ? (items.length > 1 ? 150 : 100) : 0;
  const orderTotal =
    totalSellingPrice -
    couponDiscount +
    (selectedOption === "cod" ? (items.length > 1 ? 150 : 100) : 0);

  return (
    <div style={{ marginBottom: "20px", color: "#FFF" }}>
      <div style={{ fontSize: "16px" }}>
        <strong>Items:</strong>
        <ul style={{ padding: "0px 20px" }}>
          {items.map((item) => (
            <li key={item.id}>{item.name}</li>
          ))}
        </ul>
      </div>
      <br />
      <div
        style={{
          fontSize: "16px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <strong>Subtotal: </strong>
        <div
          style={{
            width: "60%",
            height: "1px",
            backgroundColor: "#FFF",
          }}
        ></div>
        <div
          style={{
            marginLeft: "5px",
          }}
        >
          ₹ {totalBasePrice}
        </div>
      </div>
      <br />
      <div
        style={{
          fontSize: "16px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <strong>Discount: </strong>
        <div
          style={{
            width: "60%",
            height: "1px",
            backgroundColor: "#FFF",
          }}
        ></div>
        <div
          style={{
            marginLeft: "5px",
          }}
        >
          ₹ {totalDiscount}
        </div>
      </div>
      {couponData.isApplied && (
        <div>
          <br />
          <div
            style={{
              fontSize: "16px",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <strong>Coupon Discount ({couponData.code}): </strong>
            <div
              style={{
                width: "40%",
                height: "1px",
                backgroundColor: "#FFF",
              }}
            ></div>
            <div
              style={{
                marginLeft: "5px",
              }}
            >
              -₹ {couponDiscount}
            </div>
          </div>
        </div>
      )}
      {selectedOption === "cod" && (
        <div>
          <br />
          <div
            style={{
              fontSize: "16px",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <strong>COD Charges: </strong>
            <div
              style={{
                marginLeft: "5px",
                height: "1px",
                backgroundColor: "#FFF",
                width: "45%",
              }}
            ></div>
            <div
              style={{
                marginLeft: "5px",
              }}
            >
              ₹ {codCharges}
            </div>
          </div>
        </div>
      )}
      <br />
      <div
        style={{
          fontSize: "16px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <strong>Order Total: </strong>
        <div
          style={{
            marginLeft: "5px",
            height: "1px",
            backgroundColor: "#FFF",
            width: "55%",
          }}
        ></div>
        <div
          style={{
            marginLeft: "5px",
          }}
        >
          ₹ {orderTotal}
        </div>
      </div>
      <br />
    </div>
  );
};

export default ItemSummary;
